/**
 * The Action constants for the Notifications system.
 */
import constructActionTypes from 'common/utils/constructActionTypes';
import { reducerNamespace } from '../constants';

module.exports = constructActionTypes(
    {
        DELETED_PROCESS: null,
        DELETING_PROCESS: null,
        DISMISSED_PROCESS: null,
        DISMISSING_PROCESS: null,
        DISMISS_ALERT: null,
        DISPLAY_ALERT: null,
        LOADED_PROCESSES: null,
        LOADING_PROCESSES: null,
        MAXIMIZE_PROCESS_TRACKER: null,
        MINIMIZE_PROCESS_TRACKER: null,
        START_POLLING_PROCESSES: null,
        STOP_POLLING_PROCESSES: null,
        REFRESH_ON_COMPLETED_BUTTONS: null,
    },
    reducerNamespace,
);
